/******/ (function() { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ 979:
/***/ (function() {

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _wrapNativeSuper(t) { var r = "function" == typeof Map ? new Map() : void 0; return _wrapNativeSuper = function _wrapNativeSuper(t) { if (null === t || !_isNativeFunction(t)) return t; if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function"); if (void 0 !== r) { if (r.has(t)) return r.get(t); r.set(t, Wrapper); } function Wrapper() { return _construct(t, arguments, _getPrototypeOf(this).constructor); } return Wrapper.prototype = Object.create(t.prototype, { constructor: { value: Wrapper, enumerable: !1, writable: !0, configurable: !0 } }), _setPrototypeOf(Wrapper, t); }, _wrapNativeSuper(t); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _isNativeFunction(t) { try { return -1 !== Function.toString.call(t).indexOf("[native code]"); } catch (n) { return "function" == typeof t; } }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
/**
 * @class ComponentGallery
 * @extends HTMLElement
 * @description A custom web component that implements an image gallery with a main display image
 * and clickable thumbnails. The gallery allows users to switch the main image by clicking on thumbnails.
 *
 */
var ComponentGallery = /*#__PURE__*/function (_HTMLElement) {
  /**
   * @constructor
   * Creates a new ComponentGallery instance and binds the thumbnail click handler
   * to maintain correct 'this' context.
   */
  function ComponentGallery() {
    var _this;
    _classCallCheck(this, ComponentGallery);
    _this = _callSuper(this, ComponentGallery);

    // Bind methods to ensure correct 'this' context
    _this.handleThumbnailClick = _this.handleThumbnailClick.bind(_this);
    return _this;
  }

  /**
   * @method connectedCallback
   * @description Lifecycle callback that runs when the component is added to the DOM.
   * Initializes the component by caching DOM elements and setting up event listeners
   * after the DOM is fully loaded.
   */
  _inherits(ComponentGallery, _HTMLElement);
  return _createClass(ComponentGallery, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      var _this2 = this;
      document.addEventListener('DOMContentLoaded', function () {
        _this2.cacheDOM();
        _this2.addEventListeners();
      });
    }

    /**
     * @method disconnectedCallback
     * @description Lifecycle callback that runs when the component is removed from the DOM.
     * Performs cleanup by removing event listeners to prevent memory leaks.
     */
  }, {
    key: "disconnectedCallback",
    value: function disconnectedCallback() {
      this.removeEventListeners();
    }

    /**
     * @method cacheDOM
     * @description Caches important DOM elements as class properties for better performance
     * and easier access. Throws errors if required elements are not found.
     * @throws {Error} When main image element is not found
     * @throws {Error} When main image <img> element is not found
     * @throws {Error} When no thumbnails are found
     */
  }, {
    key: "cacheDOM",
    value: function cacheDOM() {
      // Find the main image container
      this.mainImage = this.querySelector('[data-main-image]');
      if (!this.mainImage) {
        throw new Error('Main image element not found');
      }

      // Find the main image element
      this.mainImageImgs = Array.from(this.mainImage.querySelectorAll('img'));
      if (this.mainImageImgs.length === 0) {
        throw new Error('No main image <img> elements found');
      }

      // Get all thumbnail elements
      this.thumbnails = Array.from(this.querySelectorAll('[data-thumbnail]'));
      if (this.thumbnails.length === 0) {
        throw new Error('No thumbnails found');
      }
    }

    /**
     * @method addEventListeners
     * @description Attaches click event listeners to all thumbnail images.
     */
  }, {
    key: "addEventListeners",
    value: function addEventListeners() {
      var _this3 = this;
      this.thumbnails.forEach(function (thumbnail) {
        thumbnail.addEventListener('click', _this3.handleThumbnailClick);
      });
    }

    /**
     * @method removeEventListeners
     * @description Removes click event listeners from all thumbnail images.
     * Called during cleanup when component is disconnected.
     */
  }, {
    key: "removeEventListeners",
    value: function removeEventListeners() {
      var _this4 = this;
      this.thumbnails.forEach(function (thumbnail) {
        thumbnail.removeEventListener('click', _this4.handleThumbnailClick);
      });
    }

    /**
     * @method handleThumbnailClick
     * @description Handles thumbnail click events by updating the main image source
     * and managing the active state of thumbnails.
     * @param {Event} event - The click event object
     */
  }, {
    key: "handleThumbnailClick",
    value: function handleThumbnailClick(event) {
      var thumbnail = event.target;
      var src = thumbnail.getAttribute('src');
      if (!src) {
        console.error('Thumbnail src attribute not found');
        return;
      }
      this.mainImageImgs.forEach(function (img) {
        // Remove any existing srcset to ensure the new src is used
        img.removeAttribute('srcset'); // Remove any existing srcset to ensure the new src is used

        // Update the main image source
        img.setAttribute('src', src);
      });

      // Update the active state of thumbnails
      this.removeActiveThumbnail();
      this.setActiveThumbnail(thumbnail);
    }

    /**
     * @method removeActiveThumbnail
     * @description Removes the 'active' class from all thumbnail elements.
     */
  }, {
    key: "removeActiveThumbnail",
    value: function removeActiveThumbnail() {
      this.thumbnails.forEach(function (thumbnail) {
        if (thumbnail) {
          thumbnail.classList.remove('active');
        }
      });
    }

    /**
     * @method setActiveThumbnail
     * @description Adds the 'active' class to the parent element of the selected thumbnail.
     * @param {HTMLElement} thumbnail - The thumbnail element to be set as active
     */
  }, {
    key: "setActiveThumbnail",
    value: function setActiveThumbnail(thumbnail) {
      if (thumbnail.parentElement) {
        thumbnail.parentElement.classList.add('active');
      }
    }
  }]);
}(/*#__PURE__*/_wrapNativeSuper(HTMLElement)); // Register the custom element with the browser
customElements.define('component-gallery', ComponentGallery);

/***/ }),

/***/ 1110:
/***/ (function() {

"use strict";

// UNUSED EXPORTS: CompareProducts

;// ./src/scripts/services/state-manager.js
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * Manages the state of products in session storage, including loading, adding, and removing products.
 */
var StateManager = /*#__PURE__*/function () {
  /**
   * Creates an instance of StateManager.
   * @param {string} storageKey - The key used to store product handles in sessionStorage.
   * @param {number} maxProducts - The maximum number of products allowed on desktop.
   * @param {number} maxMobileProducts - The maximum number of products allowed on mobile.
   */
  function StateManager(storageKey, maxProducts, maxMobileProducts) {
    _classCallCheck(this, StateManager);
    this.storageKey = storageKey;
    this.maxProducts = maxProducts;
    this.maxMobileProducts = maxMobileProducts;
  }

  /**
   * Loads products from sessionStorage and fetches their data.
   * @returns {Promise<Array<Object>>} - An array of product data objects.
   */
  return _createClass(StateManager, [{
    key: "loadProducts",
    value: (function () {
      var _loadProducts = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var storedProducts, compareProductsExpiration, isMobile, products, filteredProducts;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              // Retrieve stored product handles from sessionStorage.
              storedProducts = JSON.parse(localStorage.getItem(this.storageKey) || '[]');
              /* Check for compare_products_expiration value in local storage */
              compareProductsExpiration = localStorage.getItem('compare_products_expiration');
              /* If the compare_products_expiration value (datetime) is in the past and exists, clear the stored products */
              if (compareProductsExpiration && new Date(compareProductsExpiration) < new Date()) {
                localStorage.removeItem(this.storageKey);
                storedProducts = [];
                localStorage.removeItem('compare_products_expiration');
              }
              isMobile = window.matchMedia('(max-width: 991px)').matches;
              if (isMobile && storedProducts.length > this.maxMobileProducts) {
                storedProducts = storedProducts.slice(0, this.maxMobileProducts);
                /* Remove the last product from the session storage */
                localStorage.setItem(this.storageKey, JSON.stringify(storedProducts));
                /* Set the compare_products_expiration value to 1 day from now */
                localStorage.setItem('compare_products_expiration', new Date(Date.now() + 24 * 60 * 60 * 1000).toISOString());
              }
              // Fetch product data for each handle in parallel.
              _context.next = 7;
              return Promise.all(storedProducts.map(this.fetchProduct));
            case 7:
              products = _context.sent;
              // Filter out any products that failed to fetch (null).
              filteredProducts = products.filter(function (product) {
                return product !== null;
              });
              return _context.abrupt("return", filteredProducts);
            case 10:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function loadProducts() {
        return _loadProducts.apply(this, arguments);
      }
      return loadProducts;
    }()
    /**
     * Fetches product data from the server using the product handle.
     * @param {string} handle - The product handle.
     * @returns {Promise<Object|null>} - The product data object or null if fetching failed.
     */
    )
  }, {
    key: "fetchProduct",
    value: (function () {
      var _fetchProduct = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2(handle) {
        var response;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              _context2.next = 3;
              return fetch("".concat(window.Shopify.routes.root, "products/").concat(handle, ".js"));
            case 3:
              response = _context2.sent;
              if (response.ok) {
                _context2.next = 6;
                break;
              }
              throw new Error("HTTP error! status: ".concat(response.status));
            case 6:
              _context2.next = 8;
              return response.json();
            case 8:
              return _context2.abrupt("return", _context2.sent);
            case 11:
              _context2.prev = 11;
              _context2.t0 = _context2["catch"](0);
              // Log the error and return null to indicate failure.
              console.error("Error fetching product ".concat(handle, ":"), _context2.t0);
              return _context2.abrupt("return", null);
            case 15:
            case "end":
              return _context2.stop();
          }
        }, _callee2, null, [[0, 11]]);
      }));
      function fetchProduct(_x) {
        return _fetchProduct.apply(this, arguments);
      }
      return fetchProduct;
    }()
    /**
     * Checks if a new product can be added based on the current count and device type.
     * @returns {boolean} - True if a product can be added, false otherwise.
     */
    )
  }, {
    key: "canAddProduct",
    value: function canAddProduct(handle) {
      // Determine if the user is on a mobile device.
      var isMobile = window.matchMedia('(max-width: 991px)').matches;
      /* Check the product type of the product with the handle */
      var productType = this.fetchProduct(handle).product_type;
      return isMobile ? this.getStoredProductHandles().length < this.maxMobileProducts : this.getStoredProductHandles().length < this.maxProducts;
    }

    /**
     * Adds a product by handle if possible.
     * @param {string} handle - The product handle to add.
     * @returns {Promise<Object|null>} - The added product data or null if addition failed.
     */
  }, {
    key: "addProduct",
    value: (function () {
      var _addProduct = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3(handle) {
        var product, handles, productType;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              if (!this.canAddProduct(handle)) {
                _context3.next = 10;
                break;
              }
              _context3.next = 3;
              return this.fetchProduct(handle);
            case 3:
              product = _context3.sent;
              if (!product) {
                _context3.next = 10;
                break;
              }
              // Get the current list of stored product handles.
              handles = this.getStoredProductHandles();
              productType = product.product_type; // Add the new handle to the list.
              handles.push(handle);

              // Update the stored product handles in sessionStorage.
              this.updateStoredProductHandles(handles);

              // Return the product data.
              return _context3.abrupt("return", product);
            case 10:
              return _context3.abrupt("return", null);
            case 11:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function addProduct(_x2) {
        return _addProduct.apply(this, arguments);
      }
      return addProduct;
    }()
    /**
     * Removes a product from the stored handles by index.
     * @param {number} index - The index of the product to remove.
     */
    )
  }, {
    key: "removeProduct",
    value: function removeProduct(index) {
      // Get the current list of stored product handles.
      var handles = this.getStoredProductHandles();

      // Remove the handle at the specified index.
      handles.splice(index, 1);

      // Update the stored product handles in sessionStorage.
      this.updateStoredProductHandles(handles);
    }

    /**
     * Retrieves the list of stored product handles from sessionStorage.
     * @returns {Array<string>} - An array of product handles.
     */
  }, {
    key: "getStoredProductHandles",
    value: function getStoredProductHandles() {
      // Parse and return the stored product handles from sessionStorage.
      return JSON.parse(localStorage.getItem(this.storageKey) || '[]');
    }

    /**
     * Updates the stored product handles in sessionStorage.
     * @param {Array<string>} handles - The array of product handles to store.
     */
  }, {
    key: "updateStoredProductHandles",
    value: function updateStoredProductHandles(handles) {
      // Stringify and store the product handles in sessionStorage.
      localStorage.setItem(this.storageKey, JSON.stringify(handles));
      /* Set the compare_products_expiration value to 1 day from now, if it doesn't exist */
      if (!localStorage.getItem('compare_products_expiration')) {
        localStorage.setItem('compare_products_expiration', new Date(Date.now() + 24 * 60 * 60 * 1000).toISOString());
      }
    }
  }]);
}();
/* harmony default export */ var state_manager = (StateManager);
;// ./src/scripts/lang/algoliaTranslations.js
/**
 * @fileoverview Handles translations for Algolia search functionality by processing
 * and decoding translation strings from the global window.defaultAlgoliaTranslations object.
 */

/**
 * Object that will store the processed translation strings.
 * @type {Object.<string, string>}
 */
var languageStrings = {};

/**
 * Safely decodes URI components and HTML entities from a string.
 *
 * @param {*} str - The string to decode (or any value that might be a string)
 * @returns {*} The decoded string, or the original value if not a string or if decoding fails
 */
var safeDecodeURI = function safeDecodeURI(str) {
  try {
    // Return the input as is if it's not a string
    if (typeof str !== 'string') return str;
    var decoded = str;

    // Decode URI components (e.g., %20 → space)
    decoded = decodeURIComponent(decoded);

    // Decode HTML entities (e.g., &amp; → &) using textarea element
    var textArea = document.createElement('textarea');
    textArea.innerHTML = decoded;
    decoded = textArea.value;
    return decoded;
  } catch (e) {
    // Log the error and return the original string if decoding fails
    console.warn('Failed to decode:', str);
    console.warn('Error:', e);
    return str;
  }
};

// Process each translation string from the global Algolia translations object
Object.keys(window.defaultAlgoliaTranslations).forEach(function (key) {
  languageStrings[key] = safeDecodeURI(window.defaultAlgoliaTranslations[key]);
});

;// ./src/scripts/services/product-renderer.js
function product_renderer_typeof(o) { "@babel/helpers - typeof"; return product_renderer_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, product_renderer_typeof(o); }
function product_renderer_classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function product_renderer_defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, product_renderer_toPropertyKey(o.key), o); } }
function product_renderer_createClass(e, r, t) { return r && product_renderer_defineProperties(e.prototype, r), t && product_renderer_defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function product_renderer_toPropertyKey(t) { var i = product_renderer_toPrimitive(t, "string"); return "symbol" == product_renderer_typeof(i) ? i : i + ""; }
function product_renderer_toPrimitive(t, r) { if ("object" != product_renderer_typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != product_renderer_typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }


/**
 * Utility class for rendering product-related HTML.
 */
var ProductRenderer = /*#__PURE__*/function () {
  function ProductRenderer() {
    product_renderer_classCallCheck(this, ProductRenderer);
  }
  return product_renderer_createClass(ProductRenderer, null, [{
    key: "renderProduct",
    value:
    /**
     * Renders HTML for a product in the comparison grid.
     * @param {Object} product - The product object to render.
     * @param {string} product.id - The unique identifier of the product.
     * @param {string} product.handle - The handle (slug) of the product.
     * @param {string} product.title - The title of the product.
     * @param {string[]} product.images - An array of image URLs for the product.
     * @param {number} index - The index of the product in the comparison grid.
     * @returns {string} HTML string representing the product.
     */
    function renderProduct(product, index) {
      return "\n      <div class=\"compare-selections__item compare-selections__item--product\" data-product-id=\"".concat(product.id, "\" data-index=\"").concat(index, "\" data-product-handle=\"").concat(product.handle, "\" data-product-type=\"").concat(product.type.toLowerCase().replace(' ', '-'), "\">\n        <div class=\"compare-selections__image compare-selections__image-container\">\n          <button class=\"compare-selections__remove link hidden-desktop\" aria-label=\"Remove\" data-action=\"remove\" data-index=\"").concat(index, "\">\n            <svg width=\"30\" height=\"30\" viewBox=\"0 0 30 30\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n              <circle cx=\"15\" cy=\"15\" r=\"15\" fill=\"white\"/>\n              <rect x=\"10.2861\" y=\"18.7715\" width=\"12\" height=\"1\" rx=\"0.5\" transform=\"rotate(-45 10.2861 18.7715)\" fill=\"black\"/>\n              <rect x=\"18.7715\" y=\"19.4785\" width=\"12\" height=\"1\" rx=\"0.5\" transform=\"rotate(-135 18.7715 19.4785)\" fill=\"black\"/>\n            </svg>\n          </button>\n          <img src=\"").concat(product.featured_image.replace('.png', '_300x300.png') || this.getPlaceholderImageUrl(), "\" alt=\"").concat(product.title, "\" width=\"100\" height=\"125\" class=\"compare-selections__product-image\">\n        </div>\n        <div class=\"compare-selections__details\">\n          <h5 class=\"compare-selections__product-title\">\n            ").concat(product.title, "\n          </h5>\n          <button class=\"compare-selections__remove link hidden-mobile\" aria-label=\"Remove\" data-action=\"remove\" data-index=\"").concat(index, "\">\n            ").concat(languageStrings.remove, "\n          </button>\n        </div>\n      </div>\n    ");
    }

    /**
     * Renders HTML for a placeholder item in the comparison grid.
     * @param {number} index - The index of the placeholder in the comparison grid.
     * @returns {string} HTML string representing the placeholder.
     */
  }, {
    key: "renderPlaceholder",
    value: function renderPlaceholder(index) {
      return "\n      <div class=\"compare-selections__item compare-selections__item--placeholder\" data-index=\"".concat(index, "\" data-placeholder>\n        <div class=\"compare-selections__image\">\n        ").concat(window.matchMedia('(max-width: 991px)').matches ? this.mobilePlaceholderSVG() : "<img src=\"".concat(this.getPlaceholderImageUrl(), "\" alt=\"Product Image\" width=\"100\" height=\"125\" class=\"compare-selections__image-placeholder\">"), "\n        </div>\n        <div class=\"compare-selections__details hidden-mobile\">\n          <h5 class=\"compare-selections__placeholder-title\">").concat(languageStrings.select_another_product, "</h5>\n          <button class=\"compare-selections__remove link hidden\" aria-label=\"Remove\" data-action=\"remove\">\n            ").concat(languageStrings.remove, "\n          </button>\n        </div>\n      </div>\n    ");
    }

    /**
     * Returns the URL for the placeholder image.
     * @returns {string} The URL of the placeholder image.
     */
  }, {
    key: "getPlaceholderImageUrl",
    value: function getPlaceholderImageUrl() {
      var placeholderImage = document.querySelector('[data-placeholder-image]') ? document.querySelector('[data-placeholder-image]').getAttribute('data-placeholder-image') : '';
      return placeholderImage;
    }

    /**
     * Renders an SVG placeholder for mobile devices.
     * @returns {string} HTML string containing the SVG placeholder.
     */
  }, {
    key: "mobilePlaceholderSVG",
    value: function mobilePlaceholderSVG() {
      return "\n  <div class=\"compare-selections__details\">\n    <svg width=\"16\" height=\"16\" viewBox=\"0 0 16 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n      <rect x=\"2\" y=\"7.33398\" width=\"12\" height=\"1\" rx=\"0.5\" fill=\"black\"/>\n      <rect x=\"7.5\" y=\"13.834\" width=\"12\" height=\"1\" rx=\"0.5\" transform=\"rotate(-90 7.5 13.834)\" fill=\"black\"/>\n    </svg>\n    <h5 class=\"compare-selections__placeholder-title\">Select another product</h5>\n  </div>\n";
    }
  }]);
}();
/* harmony default export */ var product_renderer = (ProductRenderer);
;// ./src/scripts/services/dom-manager.js
function dom_manager_typeof(o) { "@babel/helpers - typeof"; return dom_manager_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, dom_manager_typeof(o); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function dom_manager_classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function dom_manager_defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, dom_manager_toPropertyKey(o.key), o); } }
function dom_manager_createClass(e, r, t) { return r && dom_manager_defineProperties(e.prototype, r), t && dom_manager_defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _defineProperty(e, r, t) { return (r = dom_manager_toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function dom_manager_toPropertyKey(t) { var i = dom_manager_toPrimitive(t, "string"); return "symbol" == dom_manager_typeof(i) ? i : i + ""; }
function dom_manager_toPrimitive(t, r) { if ("object" != dom_manager_typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != dom_manager_typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }



/**
 * Manages DOM interactions for the product comparison component.
 */
var DOMManager = /*#__PURE__*/function () {
  /**
   * Creates an instance of DOMManager.
   * @param {HTMLElement} component - The root element of the product comparison component.
   */
  function DOMManager(component) {
    var _this = this;
    dom_manager_classCallCheck(this, DOMManager);
    /**
     * Handle compare products updated event
     */
    _defineProperty(this, "handleCompareProductsUpdated", function () {
      var that = _this;
      try {
        var storedProducts = JSON.parse(localStorage.getItem('compare_products')) || [];
        _this.state.productCount = storedProducts.length;
        _this.updateCompareCount(_this.state.productCount, 'handleCompareProductsUpdated');
        if (_this.state.productCount === 0) {
          _this.compareStart.forEach(function (item) {
            return item.classList.add('disabled');
          });
        } else {
          setTimeout(function () {
            _this.compareStart.forEach(function (item) {
              return item.classList.remove('disabled');
            });
          }, 500);
        }
      } catch (error) {
        console.error('Error handling compare products updated:', error);
      }
    });
    /**
     * Cancels the comparison and updates UI accordingly.
     */
    _defineProperty(this, "cancelCompare", function () {
      _this.component.classList.remove('compare-products--open');
      _this.component.classList.add('compare-products--cancelled');
      var searchHeader = document.querySelector('.ais-page .ais-search-header');
      if (searchHeader && window.matchMedia('(max-width: 990px)').matches) {
        searchHeader.classList.remove('layer-max');
      }
      document.body.classList.remove('compare-products--no-scroll');
      _this.state.scroll_disabled = false;

      // Update state
      _this.state.closed_and_cancelled = true;
      _this.state.open_and_expanded = false;
      _this.state.open_but_minimised = false;
      _this.updateCompareButtonsText();
      _this.updateCompareButtonsActiveState(_this.state.productCount);
    });
    // Toggle the text content of compare buttons
    _defineProperty(this, "updateCompareButtonsText", function () {
      var compareButtons = _toConsumableArray(document.querySelectorAll('[js-show-compare]'));

      // Use the state to determine button text
      if (_this.state.closed_and_cancelled) {
        compareButtons.forEach(function (comp) {
          return comp.textContent = comp.dataset.labelCompare;
        });
      } else if (_this.state.open_and_expanded || _this.state.open_but_minimised) {
        compareButtons.forEach(function (comp) {
          return comp.textContent = comp.dataset.labelCancel;
        });
      }
    });
    _defineProperty(this, "updateCompareButtonsTextMobile", function () {
      _this.updateCompareButtonsActiveState(_this.state.productCount);
      return _toConsumableArray(document.querySelectorAll('[js-show-compare]')).forEach(function (comp) {
        return comp.textContent = comp.dataset.labelCancel;
      });
    });
    _defineProperty(this, "clearCompare", function () {
      var sideFilter = document.querySelector('.ais-facets');
      _this.component.classList.remove('compare-products--open');
      _this.component.classList.add('compare-products--cancelled');
      sideFilter.classList.remove('expand-bottom-space');
      document.body.classList.remove('compare-products--no-scroll');
      _this.state.scroll_disabled = false;
      var allItems = _this.component.querySelectorAll('.compare-selections__items .compare-selections__item.compare-selections__item--product');

      // allItems.forEach((_item, index) => this.component.removeProduct(index));

      // Reset product count in state
      _this.state.productCount = 0;
      _this.updateCompareCount(0, 'clearCompare');

      // Update state
      _this.state.closed_and_cancelled = true;
      _this.state.open_and_expanded = false;
      _this.state.open_but_minimised = false;
      _this.updateCompareButtonsText();
      _this.updateCompareButtonsActiveState(0);

      // Update local storage for consistency
      localStorage.setItem('compare_products', JSON.stringify([]));

      // Dispatch event to notify other components
      document.dispatchEvent(new CustomEvent('compareProductsUpdated'));
      document.dispatchEvent(new CustomEvent('compareProductCountUpdated', {
        bubbles: false,
        detail: {
          product_count: _this.state.productCount,
          closed_and_cancelled: true,
          source: 'clearCompare'
        }
      }));
    });
    this.component = component;
    this.compareProductsGrid = _toConsumableArray(component.querySelectorAll('.compare-selections__items'));
    this.compareCount = _toConsumableArray(document.querySelectorAll('[data-compare-count]'));
    this.compareOpen = _toConsumableArray(component.querySelectorAll('.compare-products__open'));
    this.compareOpenMobile = _toConsumableArray(component.querySelectorAll('.compare-products__open--mobile'));
    this.compareCancel = component.querySelector('[data-action="close"]');
    this.compareClear = component.querySelector('[data-action="clear"]');
    this.compareStart = _toConsumableArray(component.querySelectorAll('[data-action="start-comparing"]'));
    this.errorContainer = component.querySelector('.compare-products__error') || this.createErrorContainer();

    // State to track products count
    this.state = {
      productCount: 0,
      maxDesktopProducts: component.maxProducts || 3,
      maxMobileProducts: component.maxMobileProducts || 2,
      closed_and_cancelled: true,
      open_and_expanded: false,
      open_but_minimised: false
    };

    // Initialize product count from localStorage
    this.initializeProductCount();
  }

  /**
   * Initialize product count from localStorage
   */
  return dom_manager_createClass(DOMManager, [{
    key: "initializeProductCount",
    value: function initializeProductCount() {
      try {
        var storedProducts = JSON.parse(localStorage.getItem('compare_products')) || [];
        this.state.productCount = storedProducts.length;
        this.updateCompareCount(this.state.productCount, 'initializeProductCount');
        if (this.state.productCount === 0) {
          this.compareStart.forEach(function (item) {
            return item.classList.add('disabled');
          });
        } else {
          this.compareStart.forEach(function (item) {
            return item.classList.remove('disabled');
          });
        }
      } catch (error) {
        console.error('Error initializing product count:', error);
        this.state.productCount = 0;
      }
    }
  }, {
    key: "addUIListeners",
    value: function addUIListeners() {
      return this.addEventListeners();
    }
  }, {
    key: "modalClickedOutside",
    value: function modalClickedOutside() {
      this.toggleOpen('outsideClick');
    }

    /**
     * Adds event listeners to various elements.
     */
  }, {
    key: "addEventListeners",
    value: function addEventListeners() {
      var _this2 = this;
      this.handleToggleOpen = this.toggleOpen.bind(this);
      this.handleMinimizeCompareProducts = this.minimizeCompareProducts.bind(this);
      this.handleExpandCompareProducts = this.expandCompareProducts.bind(this);
      this.handleCompareSetToOpenAndMinimized = this.compareSetToOpenAndMinimized.bind(this);
      var that = this;
      if (window.matchMedia('(max-width: 991px)').matches) {
        this.compareOpenMobile.forEach(function (el) {
          el.removeEventListener('click', that.toggleOpen.bind(_this2));
          if (el.getAttribute('js-event-listener') === 'true') return;
          el.addEventListener('click', that.toggleOpen.bind(_this2));
          el.setAttribute('js-event-listener', 'true');
        });
        that.component.addEventListener('click', function (e) {
          if (!e.target.classList.contains('compare-products__container') && !e.target.closest('.compare-products__container')) {
            that.modalClickedOutside();
          }
        });
      } else {
        this.compareOpen.forEach(function (el) {
          el.removeEventListener('click', that.toggleOpen.bind(_this2));
          if (el.getAttribute('js-event-listener') === 'true') return;
          el.addEventListener('click', that.toggleOpen.bind(_this2));
          el.setAttribute('js-event-listener', 'true');
        });
      }
      if (this.compareCancel) {
        this.compareCancel.addEventListener('click', that.cancelCompare);
      }
      if (this.compareClear) {
        this.compareClear.addEventListener('click', that.clearCompare);
      }
      this.compareStart.forEach(function (item) {
        return item.addEventListener('click', that.compareModalOpen);
      });

      // Add listeners to placeholder elements
      _toConsumableArray(document.querySelectorAll('[data-placeholder]')).forEach(function (item) {
        return item.addEventListener('click', _this2.handleCompareSetToOpenAndMinimized);
      });

      // Listen for product count changes from CardProductAlt
      document.addEventListener('compareProductsUpdated', this.handleCompareProductsUpdated.bind(this));
    }
  }, {
    key: "compareSetToOpenAndMinimized",
    value: function compareSetToOpenAndMinimized() {
      // Update state first
      this.state.closed_and_cancelled = false;
      this.state.open_but_minimised = true;
      this.state.open_and_expanded = false;

      // Mobile first, trigger click on mobile buttons
      _toConsumableArray(document.querySelectorAll('.compare-products__open--mobile[js-event-listener]')).forEach(function (item) {
        item.dispatchEvent(new Event('click'), {
          bubbles: false
        });
      });

      // Desktop buttons
      _toConsumableArray(document.querySelectorAll('.compare-products__open')).forEach(function (item) {
        item.dispatchEvent(new Event('click'), {
          bubbles: false
        });
      });

      // Add minimized class if not already there
      if (!this.component.classList.contains('compare-products--minimized')) {
        this.minimizeCompareProducts();
      }
      this.updateCompareButtonsText();
      this.updateCompareButtonsActiveState(this.state.productCount);
    }
  }, {
    key: "removeEventListeners",
    value:
    /**
     * Removes event listeners from elements.
     */
    function removeEventListeners() {
      var _this3 = this;
      this.compareOpen.forEach(function (el) {
        return el.removeEventListener('click', _this3.toggleOpen.bind(_this3));
      });
      this.compareOpenMobile.forEach(function (el) {
        return el.removeEventListener('click', _this3.toggleOpen.bind(_this3));
      });
    }

    /**
     * Toggles the open state of the comparison component.
     */
  }, {
    key: "toggleOpen",
    value: function toggleOpen() {
      var source = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'toggleOpen';
      var isMobile = window.matchMedia('(max-width: 990px)').matches;
      var cancelledClassApplied = this.component.classList.contains('compare-products--cancelled');
      this.component.classList.toggle('compare-products--open');
      var searchHeader = document.querySelector('.ais-page .ais-search-header');
      if (searchHeader && isMobile) {
        searchHeader.classList.toggle('layer-max');
      }
      this.state.scroll_disabled ? document.body.classList.remove('compare-products--no-scroll') : document.body.classList.add('compare-products--no-scroll');
      this.state.scroll_disabled = !this.state.scroll_disabled;

      // Update state based on component classes
      var isOpen = this.component.classList.contains('compare-products--open');
      if (isOpen) {
        this.state.closed_and_cancelled = false;
        if (isMobile) {
          this.state.open_and_expanded = true;
          this.state.open_but_minimised = false;
        } else {
          this.state.open_and_expanded = true;
          this.state.open_but_minimised = false;
        }
      } else {
        if (cancelledClassApplied) {
          this.state.closed_and_cancelled = true;
          this.state.open_and_expanded = false;
          this.state.open_but_minimised = false;
        } else {
          this.state.closed_and_cancelled = false;
          this.state.open_and_expanded = false;
          this.state.open_but_minimised = true;
        }
      }
      if (!cancelledClassApplied) {
        this.updateCompareButtonsTextMobile();
      } else {
        this.updateCompareButtonsText();
      }
      this.updateCompareButtonsActiveState(this.state.productCount);
      if (this.state.open_but_minimised) {
        this.state.scroll_disabled = false;
        document.body.classList.remove('compare-products--no-scroll');
      }
    }
  }, {
    key: "updateCompareButtonsActiveState",
    value: function updateCompareButtonsActiveState() {
      var prod_length = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      var compareButtons = _toConsumableArray(document.querySelectorAll('button[aria-label="Compare"]'));
      if (prod_length === 0) {
        compareButtons.forEach(function (button) {
          return button.classList.remove('active');
        });
      }
      if (this.state.open_and_expanded || this.state.open_but_minimised) {
        compareButtons.forEach(function (button) {
          return button.classList.add('active');
        });
      } else if (this.state.closed_and_cancelled) {
        compareButtons.forEach(function (button) {
          return button.classList.remove('active');
        });
      }
    }
  }, {
    key: "compareModalOpen",
    value:
    /**
     * Opens the comparison modal.
     */
    function compareModalOpen() {
      document.querySelector('.compare-products-modal').classList.toggle('compare-products-modal--open');
      document.dispatchEvent(new CustomEvent('compareProductsModalOpened'));
    }
  }, {
    key: "render",
    value: function render() {
      var products = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      this.renderProducts(products);
      this.renderPlaceholders(products.length);
      this.updateCompareCount(products.length);
    }

    /**
     * Renders the products in the comparison grid.
     * @param {Array} products - An array of product objects to render.
     */
  }, {
    key: "renderProducts",
    value: function renderProducts(products) {
      var _this4 = this;
      var isMobile = window.matchMedia('(max-width: 991px)').matches;
      if (isMobile) {
        this.compareProductsGrid = this.compareProductsGrid.filter(function (grid) {
          return !grid.classList.contains('compare-selections__items--desktop');
        });
      } else {
        this.compareProductsGrid = this.compareProductsGrid.filter(function (grid) {
          return !grid.classList.contains('compare-selections__items--mobile');
        });
      }

      // Clear existing products
      this.compareProductsGrid.forEach(function (grid) {
        grid.innerHTML = '';
      });

      // Render new products
      products.forEach(function (product, index) {
        if (product) {
          var productElement = _this4.createProductElement(product, index);
          _this4.compareProductsGrid.forEach(function (gridItem) {
            gridItem.appendChild(productElement);
          });
        }
      });

      // Update product count in state
      this.state.productCount = products.length;
      this.updateCompareCount(products.length, 'renderProducts');
      this.updateCompareButtonsActiveState(products.length);
    }

    /**
     * Creates a product element for rendering.
     * @param {Object} product - The product object to render.
     * @param {number} index - The index of the product in the list.
     * @returns {HTMLElement} The created product element.
     */
  }, {
    key: "createProductElement",
    value: function createProductElement(product, index) {
      var _this5 = this;
      var template = document.createElement('template');
      template.innerHTML = product_renderer.renderProduct(product, index).trim();
      var element = template.content.firstChild;

      // Add remove event listener
      setTimeout(function () {
        _toConsumableArray(element.querySelectorAll('[data-action="remove"]')).forEach(function (remove) {
          remove.addEventListener('click', function () {
            _this5.component.removeProduct(index);
            var storedProducts = JSON.parse(localStorage.getItem('compare_products')) || [];
            _this5.state.productCount = Math.max(0, _this5.state.productCount - 1);
            if (_this5.state.productCount !== storedProducts.length) {
              _this5.updateCompareCount(storedProducts.length, 'removeProduct and createProductElement 1');
            } else {
              _this5.updateCompareCount(_this5.state.productCount, 'removeProduct and createProductElement 2');
            }
          });
        });
      }, 1000);
      return element;
    }

    /**
     * Renders placeholder elements for empty product slots.
     * @param {number} productCount - The current number of products.
     */
  }, {
    key: "renderPlaceholders",
    value: function renderPlaceholders(productCount) {
      var _this6 = this;
      var isMobile = window.matchMedia('(max-width: 991px)').matches;
      var placeholdersNeeded = isMobile ? this.state.maxMobileProducts - productCount : this.state.maxDesktopProducts - productCount;
      var _loop = function _loop() {
        var placeholder = _this6.createPlaceholderElement(productCount + i);
        _this6.compareProductsGrid.forEach(function (grid) {
          return grid.appendChild(placeholder);
        });
      };
      for (var i = 0; i < placeholdersNeeded; i++) {
        _loop();
      }
      _toConsumableArray(document.querySelectorAll('[data-placeholder]')).forEach(function (item) {
        item.addEventListener('click', _this6.handleCompareSetToOpenAndMinimized);
      });

      // Update product count in state
      this.state.productCount = productCount;
      this.updateCompareButtonsActiveState(productCount);
    }

    /**
     * Creates a placeholder element.
     * @param {number} index - The index for the placeholder.
     * @returns {HTMLElement} The created placeholder element.
     */
  }, {
    key: "createPlaceholderElement",
    value: function createPlaceholderElement(index) {
      var template = document.createElement('template');
      template.innerHTML = product_renderer.renderPlaceholder(index).trim();
      return template.content.firstChild;
    }

    /**
     * Updates the product count display.
     * @param {number} count - The current number of products being compared.
     */
  }, {
    key: "updateCompareCount",
    value: function updateCompareCount(count) {
      var source = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'updateCompareCount';
      var isMobile = window.matchMedia('(max-width: 991px)').matches;
      var maxProducts = isMobile ? this.state.maxMobileProducts : this.state.maxDesktopProducts;
      this.compareCount.forEach(function (item) {
        var countSpan = item.querySelector('span');
        if (countSpan) {
          countSpan.textContent = "(".concat(count, " ").concat(languageStrings.of, " ").concat(maxProducts, ")");
        }
      });

      // Update state
      this.state.productCount = count;
      document.dispatchEvent(new CustomEvent('compareProductCountUpdated', {
        bubbles: false,
        detail: {
          product_count: this.state.productCount,
          source: source,
          states: this.state
        },
        once: true
      }));
    }

    /**
     * Displays an error message.
     * @param {string} message - The error message to display.
     */
  }, {
    key: "showError",
    value: function showError(message) {
      var _this7 = this;
      this.errorContainer.textContent = message;
      this.errorContainer.classList.remove('hidden');
      setTimeout(function () {
        _this7.errorContainer.classList.add('hidden');
      }, 5000);
    }

    /**
     * Creates an error container if it doesn't exist.
     * @returns {HTMLElement} The created error container.
     */
  }, {
    key: "createErrorContainer",
    value: function createErrorContainer() {
      var container = document.createElement('div');
      container.className = 'compare-products__error hidden';
      this.component.appendChild(container);
      return container;
    }

    /**
     * Minimizes the compare products container (for desktop).
     */
  }, {
    key: "minimizeCompareProducts",
    value: function minimizeCompareProducts() {
      if (this.component) {
        this.state.closed_and_cancelled = false;
        this.state.open_and_expanded = false;
        this.state.open_but_minimised = true;
        var isMobile = window.matchMedia('(max-width: 991px)').matches;
        // Add appropriate classes

        if (!isMobile) {
          this.component.classList.add('compare-products--open');
        }
        this.component.classList.remove('compare-products--cancelled');
        this.component.classList.add('compare-products--minimized');

        // Don't disable scrolling in minimized state
        document.body.classList.remove('compare-products--no-scroll');
        this.state.scroll_disabled = false;

        // Update button text
        this.updateCompareButtonsText();
        this.updateCompareButtonsActiveState(this.state.productCount);
      }
    }

    /**
     * Expands the compare products container from minimized state.
     */
  }, {
    key: "expandCompareProducts",
    value: function expandCompareProducts() {
      if (this.component) {
        this.state.closed_and_cancelled = false;
        this.state.open_and_expanded = true;
        this.state.open_but_minimised = false;

        // Add appropriate classes
        this.component.classList.add('compare-products--open');
        this.component.classList.remove('compare-products--cancelled');
        this.component.classList.remove('compare-products--minimized');

        // Re-enable no-scroll on body for full expanded view
        document.body.classList.add('compare-products--no-scroll');
        this.state.scroll_disabled = true;

        // Update button text
        this.updateCompareButtonsText();
        this.updateCompareButtonsActiveState(this.state.productCount);
      }
    }
  }]);
}();
/* harmony default export */ var dom_manager = (DOMManager);
;// ./src/scripts/utils/debounce.js
var Debounce = function Debounce(fn, delay) {
  var timeout;
  return function () {
    var context = this;
    var args = arguments;
    clearTimeout(timeout);
    timeout = setTimeout(function () {
      return fn.apply(context, args);
    }, delay);
  };
};
var debounce = function debounce(func, wait, immediate) {
  var timeout;
  return function () {
    var context = this,
      args = arguments;
    var later = function later() {
      timeout = null;
      if (!immediate) func.apply(context, args);
    };
    var callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow) func.apply(context, args);
  };
};

;// ./src/scripts/snippets/compare-products-component.js
function compare_products_component_typeof(o) { "@babel/helpers - typeof"; return compare_products_component_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, compare_products_component_typeof(o); }
function compare_products_component_regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ compare_products_component_regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == compare_products_component_typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(compare_products_component_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function compare_products_component_asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function compare_products_component_asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { compare_products_component_asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { compare_products_component_asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function compare_products_component_classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function compare_products_component_defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, compare_products_component_toPropertyKey(o.key), o); } }
function compare_products_component_createClass(e, r, t) { return r && compare_products_component_defineProperties(e.prototype, r), t && compare_products_component_defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function compare_products_component_toPropertyKey(t) { var i = compare_products_component_toPrimitive(t, "string"); return "symbol" == compare_products_component_typeof(i) ? i : i + ""; }
function compare_products_component_toPrimitive(t, r) { if ("object" != compare_products_component_typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != compare_products_component_typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == compare_products_component_typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _wrapNativeSuper(t) { var r = "function" == typeof Map ? new Map() : void 0; return _wrapNativeSuper = function _wrapNativeSuper(t) { if (null === t || !_isNativeFunction(t)) return t; if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function"); if (void 0 !== r) { if (r.has(t)) return r.get(t); r.set(t, Wrapper); } function Wrapper() { return _construct(t, arguments, _getPrototypeOf(this).constructor); } return Wrapper.prototype = Object.create(t.prototype, { constructor: { value: Wrapper, enumerable: !1, writable: !0, configurable: !0 } }), _setPrototypeOf(Wrapper, t); }, _wrapNativeSuper(t); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _isNativeFunction(t) { try { return -1 !== Function.toString.call(t).indexOf("[native code]"); } catch (n) { return "function" == typeof t; } }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }




/**
 * Custom element for comparing products.
 * @extends HTMLElement
 */
var CompareProducts = /*#__PURE__*/function (_HTMLElement) {
  function CompareProducts() {
    var _this;
    compare_products_component_classCallCheck(this, CompareProducts);
    _this = _callSuper(this, CompareProducts);

    // Default configuration (overridable via attributes)
    _this._config = {
      maxProducts: Number(_this.getAttribute('max-products')) || 3,
      maxMobileProducts: Number(_this.getAttribute('max-mobile-products')) || 2
    };

    // Initialize services once
    _this._stateManager = new state_manager('compare_products', _this._config.maxProducts, _this._config.maxMobileProducts);
    _this._domManager = new dom_manager(_this, _this._config);

    // Debounced refresh handler for resize
    _this._onResize = Debounce(_this._refresh.bind(_this), 100);
    // Handler for Algolia initialization or manual refresh
    _this._onAlgoliaInit = _this._refresh.bind(_this);
    // Custom event handler for product updates
    _this._onProductsUpdated = _this._refresh.bind(_this);
    return _this;
  }

  /**
   * Lifecycle: connected to DOM
   */
  _inherits(CompareProducts, _HTMLElement);
  return compare_products_component_createClass(CompareProducts, [{
    key: "connectedCallback",
    value: (function () {
      var _connectedCallback = compare_products_component_asyncToGenerator(/*#__PURE__*/compare_products_component_regeneratorRuntime().mark(function _callee() {
        return compare_products_component_regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return this._refresh('connectedCallback');
            case 2:
              // Listen for external triggers
              document.addEventListener('compareProductsUpdated', this._onProductsUpdated);
              window.addEventListener('resize', this._onResize);
              window.addEventListener('algolia.finishedInitialization', this._onAlgoliaInit);

              // Delegate UI events via DOMManager
              this._domManager.addUIListeners();
            case 6:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function connectedCallback() {
        return _connectedCallback.apply(this, arguments);
      }
      return connectedCallback;
    }()
    /**
     * Lifecycle: disconnected from DOM
     */
    )
  }, {
    key: "disconnectedCallback",
    value: function disconnectedCallback() {
      document.removeEventListener('compareProductsUpdated', this._onProductsUpdated);
      window.removeEventListener('resize', this._onResize);
      window.removeEventListener('algolia.finishedInitialization', this._onAlgoliaInit);
      this._domManager.removeUIListeners();
    }

    /**
     * Handle attribute changes for configuration
     */
  }, {
    key: "attributeChangedCallback",
    value: function attributeChangedCallback(name, oldVal, newVal) {
      if (oldVal === newVal) return;
      this._config = {
        maxProducts: Number(this.getAttribute('max-products')) || this._config.maxProducts,
        maxMobileProducts: Number(this.getAttribute('max-mobile-products')) || this._config.maxMobileProducts
      };
      this._stateManager.updateLimits(this._config.maxProducts, this._config.maxMobileProducts);
      this._domManager.updateConfig(this._config);
      this._refresh('attributeChangedCallback');
    }

    /**
     * Reload state and re-render
     * @private
     */
  }, {
    key: "_refresh",
    value: (function () {
      var _refresh2 = compare_products_component_asyncToGenerator(/*#__PURE__*/compare_products_component_regeneratorRuntime().mark(function _callee2() {
        var source,
          products,
          _args2 = arguments;
        return compare_products_component_regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              source = _args2.length > 0 && _args2[0] !== undefined ? _args2[0] : 'refresh';
              _context2.prev = 1;
              _context2.next = 4;
              return this._stateManager.loadProducts();
            case 4:
              products = _context2.sent;
              if (source.type === 'algolia.finishedInitialization') {}
              this._domManager.render(products);
              this._emitRefreshEvents();
              _context2.next = 14;
              break;
            case 10:
              _context2.prev = 10;
              _context2.t0 = _context2["catch"](1);
              console.error('CompareProducts refresh error:', _context2.t0);
              this._domManager.showError('Failed to load products. Please try again later.');
            case 14:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this, [[1, 10]]);
      }));
      function _refresh() {
        return _refresh2.apply(this, arguments);
      }
      return _refresh;
    }()
    /**
     * Emit standardized custom events post-render
     * @private
     */
    )
  }, {
    key: "_emitRefreshEvents",
    value: function _emitRefreshEvents() {
      // Use bubbling and composed so other components can listen
      this.dispatchEvent(new CustomEvent('compareUpdatedRefreshCards', {
        bubbles: true,
        composed: true
      }));
      this.dispatchEvent(new CustomEvent('compareProductsUpdatedDrawer', {
        bubbles: true,
        composed: true
      }));
    }

    /**
     * Public API: add a product by handle
     * @param {string} handle
     */
  }, {
    key: "addProduct",
    value: (function () {
      var _addProduct = compare_products_component_asyncToGenerator(/*#__PURE__*/compare_products_component_regeneratorRuntime().mark(function _callee3(handle) {
        var product;
        return compare_products_component_regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.prev = 0;
              if (this._stateManager.canAddProduct()) {
                _context3.next = 4;
                break;
              }
              this._domManager.showError("Cannot add more than ".concat(this._config.maxProducts, " products."));
              return _context3.abrupt("return");
            case 4:
              _context3.next = 6;
              return this._stateManager.addProduct(handle);
            case 6:
              product = _context3.sent;
              if (product) this._refresh('addProduct');
              _context3.next = 14;
              break;
            case 10:
              _context3.prev = 10;
              _context3.t0 = _context3["catch"](0);
              console.error("Error adding product ".concat(handle, ":"), _context3.t0);
              this._domManager.showError('Failed to add product. Please try again later.');
            case 14:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this, [[0, 10]]);
      }));
      function addProduct(_x) {
        return _addProduct.apply(this, arguments);
      }
      return addProduct;
    }()
    /**
     * Public API: remove a product by index
     * @param {number} index
     */
    )
  }, {
    key: "removeProduct",
    value: function removeProduct(index) {
      try {
        this._stateManager.removeProduct(index);
        this._refresh('removeProduct');
      } catch (error) {
        console.error("Error removing product at index ".concat(index, ":"), error);
        this._domManager.showError('Failed to remove product. Please try again later.');
      }
    }
  }], [{
    key: "observedAttributes",
    get:
    /**
     * Observe changes to configuration attributes.
     */
    function get() {
      return ['max-products', 'max-mobile-products'];
    }
  }]);
}(/*#__PURE__*/_wrapNativeSuper(HTMLElement));
customElements.define('compare-products', CompareProducts);


/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	!function() {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = function(module) {
/******/ 			var getter = module && module.__esModule ?
/******/ 				function() { return module['default']; } :
/******/ 				function() { return module; };
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	!function() {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = function(exports, definition) {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	!function() {
/******/ 		__webpack_require__.o = function(obj, prop) { return Object.prototype.hasOwnProperty.call(obj, prop); }
/******/ 	}();
/******/ 	
/************************************************************************/
// This entry needs to be wrapped in an IIFE because it needs to be in strict mode.
!function() {
"use strict";
/* harmony import */ var _snippets_compare_products_component_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1110);
/* harmony import */ var _components_ComponentGallery_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(979);
/* harmony import */ var _components_ComponentGallery_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_components_ComponentGallery_js__WEBPACK_IMPORTED_MODULE_1__);
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }



// The theme used to store its own Algolia user token here; Algolia never received it. Drop the
// leftover. Remove this block after 2027-03-31.
try {
  localStorage.removeItem('algolia_user_token');
} catch (_unused) {
  // Storage is unavailable, so there is nothing to clean up.
}
(function () {
  var elementEventListeners = new WeakMap();
  var originalAddEventListener = EventTarget.prototype.addEventListener;
  var originalRemoveEventListener = EventTarget.prototype.removeEventListener;
  EventTarget.prototype.addEventListener = function (type, listener, options) {
    if (this && (_typeof(this) === 'object' || typeof this === 'function')) {
      if (!elementEventListeners.has(this)) {
        elementEventListeners.set(this, []);
      }
      elementEventListeners.get(this).push({
        type: type,
        listener: listener,
        options: options
      });
    } else {
      console.warn('Invalid "this" encountered in addEventListener:', this);
    }
    originalAddEventListener.call(this, type, listener, options);
  };
  EventTarget.prototype.removeEventListener = function (type, listener, options) {
    if (this && elementEventListeners.has(this)) {
      var listeners = elementEventListeners.get(this);
      // Find and remove the listener from our storage
      for (var i = 0; i < listeners.length; i++) {
        var l = listeners[i];
        if (l.type === type && l.listener === listener && l.options === options) {
          listeners.splice(i, 1);
          break;
        }
      }
    }
    // Call the original removeEventListener method
    originalRemoveEventListener.call(this, type, listener, options);
  };
  window.getAndRemoveClickEventListeners = function (element) {
    if (elementEventListeners.has(element)) {
      var listeners = elementEventListeners.get(element);

      // Filter out the 'mousedown' listeners
      var clickListeners = listeners.filter(function (l) {
        return l.type === 'click';
      });

      // Remove each 'click' listener
      clickListeners.forEach(function (l, i) {
        if (clickListeners.length === i + 1) {
          return;
        } else {
          element.removeEventListener(l.type, l.listener, l.options);
        }
      });

      // Update the stored listeners to exclude the removed ones
      elementEventListeners.set(element, listeners.filter(function (l) {
        return l.type !== 'click';
      }));

      // Return the removed 'mousedown' listeners
      return clickListeners;
    } else {
      return [];
    }
  };
  window.getRemainingClickEventListeners = function (element) {
    if (elementEventListeners.has(element)) {
      var listeners = elementEventListeners.get(element);
      return listeners.filter(function (l) {
        return l.type === 'click';
      });
    } else {
      return [];
    }
  };
})();
}();
/******/ })()
;